export var MailIconsDefinitions = {
    Accounts: '\ue910',
    Broom: '\uea99',
    ChevronDownSmall: '\ue96e',
    ChevronRightSmall: '\ue970',
    ChevronUpSmall: '\ue96d',
    ChromeMinimize: '\ue921',
    CoffeeScript: '\uf2fa',
    DateTime2: '\uea17',
    DietPlanNotebook: '\ueac8',
    Dislike: '\ue8e0',
    DislikeSolid: '\uf3c0',
    Drm: '\ueca8',
    FabricMovetoFolder: '\uf0a5',
    Fax: '\uef5c',
    FileBug: '\uf30d',
    Giftbox: '\uec1f',
    IRMForward: '\uf41f',
    IRMReply: '\uf41d',
    LikeSolid: '\uf3bf',
    Memo: '\ue77c',
    MultiSelectMirrored: '\uea98',
    NotePinned: '\ued9a',
    OutOfOffice: '\ued34',
    Pin: '\ue718',
    QuickNote: '\ue70b',
    Read: '\ue8c3',
    ReadingMode: '\ue736',
    ReceiptCheck: '\uef5b',
    ReceiptForward: '\uef59',
    ReceiptReply: '\uef5a',
    RecurringTask: '\uedb2',
    RevToggleKey: '\ue845',
    ShoppingCart: '\ue7bf',
    Suitcase: '\uedd3',
    UserOptional: '\uf767',
    Vacation: '\uf49f',
    VerifiedBrand: '\uf7bd',
    VoicemailForward: '\ued87',
    VoicemailIRM: '\uf421',
    VoicemailReply: '\ued88',
};
export default {
    fontFileName: 'mailIcons',
    icons: MailIconsDefinitions,
};
//# sourceMappingURL=mailIconsRegistration.js.map